import React, { useEffect } from "react";
import InfoPopupConditionsSection from "./info-popup/InfoPopupConditionsSection";
import InfoPopupDetailsSection from "./info-popup/InfoPopupDetailsSection";
import InfoPopupHeaderSection from "./info-popup/InfoPopupHeaderSection";
import InfoPopupRatingsActionsSection from "./info-popup/InfoPopupRatingsActionsSection";
import useInfoPopupView, {
  calculateLocationRating,
} from "./info-popup/useInfoPopupView";

export { calculateLocationRating };

export default function InfoPopup(props) {
  const infoPopup = useInfoPopupView(props);
  const hasPost = Boolean(infoPopup.post);

  useEffect(() => {
    if (!hasPost || typeof window === "undefined") {
      return undefined;
    }

    const { document } = window;
    const html = document.documentElement;
    const body = document.body;
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const previousHtmlOverflow = html.style.overflow;
    const previousBodyOverflow = body.style.overflow;
    const previousBodyPosition = body.style.position;
    const previousBodyTop = body.style.top;
    const previousBodyWidth = body.style.width;

    html.classList.add("info-popup-scroll-locked");
    body.classList.add("info-popup-scroll-locked");
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";

    return () => {
      html.classList.remove("info-popup-scroll-locked");
      body.classList.remove("info-popup-scroll-locked");
      html.style.overflow = previousHtmlOverflow;
      body.style.overflow = previousBodyOverflow;
      body.style.position = previousBodyPosition;
      body.style.top = previousBodyTop;
      body.style.width = previousBodyWidth;
      window.scrollTo(0, scrollY);
    };
  }, [hasPost]);

  const popupContentClassName = [
    "saved-location-popup-inner",
    "info-popup-content",
    infoPopup.enableVerticalScroll ? "info-popup-scrollable" : ""
  ]
    .filter(Boolean)
    .join(" ");

  const popupWrapperClassName = [
    "saved-location-popup",
    "info-popup-shell",
    infoPopup.enableVerticalScroll ? "info-popup-viewport-fit" : ""
  ]
    .filter(Boolean)
    .join(" ");

  const popupBodyClassName = infoPopup.enableVerticalScroll
    ? "info-popup-scroll-body"
    : "";

  if (!hasPost) return null;

  return (
    <div className="info-popup-overlay" onClick={infoPopup.onClose}>
      <div className={popupWrapperClassName}>
        <div
          onClick={(e) => e.stopPropagation()}
          className={popupContentClassName}
        >
          <div className={popupBodyClassName}>
            <InfoPopupHeaderSection infoPopup={infoPopup} />
            <InfoPopupDetailsSection infoPopup={infoPopup} />
            <InfoPopupConditionsSection infoPopup={infoPopup} />
            <InfoPopupRatingsActionsSection infoPopup={infoPopup} />
          </div>
        </div>
      </div>
    </div>
  );
}
